import { GoodType } from '@/type/components';
import {
    CreateTemplateEnums,
    GroupMemberType,
    TemplateInfo,
    WorkOrderGroupType,
    CreateWorkOrderTemplateParams,
    UpdateWorkOrderTemplateParams,
    AddEditClassify,
    DelClassify,
    // DivideListItem,
    DivideAddParams,
    DivideEditParams,
    EnableDisabled,
    EnumList,
    // WorkOrderCategoryType,
    ConfigSwitch,
    AllTypeReason,
    ReasonItem,
} from '@/type/systemSetting';
import type { fieldItem } from '@/type/workOrderFields';
import {
    PaginationParams,
    PaginationParamsPageNum,
    PaginationResult,
    ApiDataType,
} from '@/typing';
import { getRequest, getTableRequest, postRequest } from '@/utils/request';
import { getRequest as get, postRequest as post } from '@/utils/fetch';

// =============================== 工单组

// 查询 技能组
export const getWorkOrderGroupList = () => {
    return getRequest<WorkOrderGroupType[]>(
        '/work-order/workOrder/workOrderGroup/list',
    );
};

// 获取工单流转配置所需枚举
export const getTriggeringConditionEnums = () => {
    return get<EnumList[]>(
        '/work-order/workOrder/transferConfig/getTriggeringConditionEnums',
    );
};

// 添加工单流转配置
export const addTransferConfig = (params) => {
    return post('/work-order/workOrder/transferConfig/add', params);
};
// 更新工单流转配置
export const updateTransferConfig = (params) => {
    return post('/work-order/workOrder/transferConfig/update', params);
};

// 添加工单组
export const addWorkOrderGroup = (group: WorkOrderGroupType) => {
    return postRequest('/work-order/workOrder/workOrderGroup/add', group);
};

// 删除工单组
export const deleteWorkOrderGroup = (groupId: number) => {
    return getRequest('/work-order/workOrder/workOrderGroup/delete', {
        groupId,
    });
};

// 编辑工单组
export const editWorkOrderGroup = (group: WorkOrderGroupType) => {
    return postRequest<WorkOrderGroupType>(
        '/work-order/workOrder/workOrderGroup/update',
        group,
    );
};

// 获取某个工单组的成员列表
export const getWorkOrderUserList = (groupId: number) => {
    return getRequest<GroupMemberType[]>(
        '/work-order/workOrder/workOrderGroup/getWorkOrderUserList',
        { groupId },
    );
};

// 获取全部人员列表
export const getAllMemberList = () => {
    return getRequest<GroupMemberType[]>(
        '/work-order/workOrder/workOrderGroup/getUserList',
    );
};

// 更新工单组内成员
export const updateGroupMember = (groupId: number, userIds: string[]) => {
    return postRequest(
        '/work-order/workOrder/workOrderGroup/updateGroupUserRelation',
        { groupId, userIds },
    );
};

// 更新用户自动接单状态
export const updateUserAutoReceiveStatus = (
    closeAutoReceiveUserIdList: number[],
    openAutoReceiveUserIdList: any[],
) => {
    return postRequest(
        '/work-order/workOrder/workOrderGroup/updateUserAutoReceiveStatus',
        { closeAutoReceiveUserIdList, openAutoReceiveUserIdList },
    );
};

// =============================== 工单分类

/**
 * 工单分类--分类树信息
 */
export const getClassifyTree = () => {
    return getRequest('/work-order/workOrder/category/list');
};

/**
 * 工单分类--新增根据模板查找关联分类
 */
export const getCategoresByTemplateId = (params: { templateId: number }) => {
    return get('/work-order/workOrder/category/listByTemplateId', params);
};

/**
 * 工单分类--关联模板
 */
export const getListForSelect = () => {
    return getRequest('/work-order/workOrder/template/listForSelect');
};

/**
 * 工单分类--新增分类
 */
export const getCategoryAdd = (params: AddEditClassify) => {
    return postRequest('/work-order/workOrder/category/add', params);
};

/**
 * 工单分类--更新分类
 */
export const getCategoryUpdate = (params: AddEditClassify) => {
    return postRequest('/work-order/workOrder/category/update', params);
};
/**
 * 工单分类--删除分类
 */
export const getCategoryDel = (params: DelClassify) => {
    return getRequest('/work-order/workOrder/category/del', params);
};
/**
 * 工单分类--校验分类下是否存在工单
 */
export const getCategoryExistWorkOrder = (params: DelClassify) => {
    return getRequest('/work-order/workOrder/category/existWorkOrder', params);
};

// =============================== 工单流转配置
/**
 * 工单分配--流转配置查询
 */
export const getFlowConfigList = (params: any) => {
    // return getRequest('/work-order/workOrder/flowConfig/list', params);
    return postRequest('/work-order/workOrder/transferConfig/list', params);
};

/**
 * 工单分配--流转配置详情
 */
export const getTransferConfigDetail = (params: { id: number }) => {
    // return getRequest('/work-order/workOrder/flowConfig/list', params);
    return getRequest('/work-order/workOrder/transferConfig/detail', params);
};

/**
 * 工单分配--新增配置
 */
export const getFlowConfigAdd = (params: DivideAddParams) => {
    return postRequest('/work-order/workOrder/flowConfig/add', params);
};

/**
 * 工单分配--删除配置
 */
export const getFlowConfigDel = (params: EnableDisabled) => {
    // return getRequest('/work-order/workOrder/flowConfig/del', params);
    return getRequest('/work-order/workOrder/transferConfig/del', params);
};

/**
 * 工单分配 -- 日志
 */
export const getTransferLogs = (params: { transferId?: number }) => {
    // return getRequest('/work-order/workOrder/flowConfig/del', params);
    return getRequest('/work-order/workOrder/transferConfigLog/list', params);
};

/**
 * 工单分配--禁用配置
 */
// export const getFlowConfigDisabled = (params: EnableDisabled) => {
//     return getRequest('/work-order/workOrder/flowConfig/disabled', params);
// };

/**
 * 工单分配--启用 / 停用配置
 */
export const updateFlowConfigEnable = (params: EnableDisabled) => {
    return get('/work-order/workOrder/transferConfig/enableOrDisabled', params);
};

/**
 * 工单分配--更新配置
 */
export const getFlowConfigUpdate = (params: DivideEditParams) => {
    return post('/work-order/workOrder/flowConfig/update', params);
};

// =============================== 工单模板
// 查询工单模板列表
export const getTemplateList = (params: PaginationParams<{ name: string }>) => {
    return getTableRequest<TemplateInfo>(
        '/work-order/workOrder/template/listForConfig',
        params,
    );
};

// 查询创建模板所需枚举
export const getCreateTemplateEnum = () => {
    return getRequest<CreateTemplateEnums>(
        '/work-order/workOrder/template/getCreateTemplateEnum',
    );
};

// 创建工单模板
export const createWorkOrderTemplate = (
    params: CreateWorkOrderTemplateParams,
) => {
    return postRequest('/work-order/workOrder/template/add', params);
};

// 更新工单模板
export const updateWorkOrderTemplate = (
    params: UpdateWorkOrderTemplateParams,
) => {
    return postRequest('/work-order/workOrder/template/update', params);
};

// 删除工单模板
export const deleteWorkOrderTemplate = (id: number) => {
    return getRequest('/work-order/workOrder/template/deleteTemplateById', {
        id,
    });
};

// 获取创建工单所有枚举类型
export const getAllEnums = () => {
    return getRequest<EnumList>('/work-order/workOrder/work/initPage');
};

// 查询系列名
export const searchSeries = (word: string) => {
    return postRequest<{ series_name: string }[]>(
        // '/work-order/workOrder/series/search',
        '/series/searchAll',
        { series_name: word },
    );
};

// 根据系列名搜索商品名
export const searchProductBySeries = (seriesName: string) => {
    return postRequest<GoodType[]>('/work-order/workOrder/product/searchNew', {
        seriesName,
    });
};

// 获取模板详情
export const getTemplateInfoById = (id: number) => {
    return getRequest<TemplateInfo>(
        '/work-order/workOrder/template/getTemplateById',
        { id },
    );
};

// 获取模板 所需的所有枚举
export const getTemplateEnumById = (templateId: number) => {
    return getRequest('/work-order/workOrder/work/initPageById', {
        templateId,
    });
};

// =============================== 售后审核配置

/**
 * 售后审核配置--获取售后审核配置信息
 */
export const getConfigInfo = () => {
    return getRequest('/css/audit/getConfig');
};

/**
 * 售后审核配置--更新售后审核配置
 */
export const UpdataRenew = (params: ConfigSwitch) => {
    return postRequest('/css/audit/updateConfig', params);
};

/**
 * 售后审核配置--点击日志调用接口
 */
export const getLog = (id: number) => {
    return getRequest(`/css/audit/getLogList/?audit_config_id=${id}`);
};

/**
 * 系统参数 - 更新
 */
export const updateSystemConfig = (params: {
    autoAssignTime: string;
    id: number;
    mergeAssignMaxCount: string;
}) => {
    return postRequest(`/work-order/workOrder/systemConfig/update`, params);
};
/**
 * 系统参数 - 更新
 */
export const getSystemConfig = () => {
    return getRequest(`/work-order/workOrder/systemConfig/detail`);
};

/**
 * 商品管理
 */

// 获取海鼎商品
export const getProductHd = (params) => {
    return post(`/css/virtual/product/hdProduct`, params);
};

// 获取商品列表
export const getVirtualProductList = (params) => {
    return post(`/css/virtual/product/list`, params);
};
// 添加虚拟商品
export const addProduct = (params) => {
    return post(`/css/virtual/product/add`, params);
};

// 编辑虚拟商品
export const updateProduct = (params) => {
    return post(`/css/virtual/product/update`, params);
};

// 获取商品详情
export const getProductDetailById = (params) => {
    return get(`/css/virtual/product/getById`, params);
};

// 删除商品
export const delProduct = (params) => {
    return post(`/css/virtual/product/batchDel`, params);
};
/* 自定义字段 - 列表
 */

export const getFieldsList = (data: {
    current: number;
    pageSize: number;
    fieldName: string;
}) => {
    return post('/work-order/workOrder/template/field/list', data);
};

/**
 * 自定义字段 - 新增
 */

export const createField = (data: fieldItem) => {
    return post('/work-order/workOrder/template/field/add', data);
};
/**
 * 自定义字段 - 更新
 */

export const updateField = (data: fieldItem) => {
    return post('/work-order/workOrder/template/field/update', data);
};

/**
 * 自定义字段 - 删除
 */
export const delField = (data: { field: string }) => {
    return post('/work-order/workOrder/template/field/del', data);
};

/**
 * 自定义字段 - 启用停用
 */
export const enableField = (data: { field: string; enableStatus: 1 | 2 }) => {
    return post('/work-order/workOrder/template/field/enable', data);
};

/**
 * 自定义导出字段 - 导出字段启用停用
 */
export const downloadEnableField = (data: {
    field: string;
    enableStatus: 1 | 2;
}) => {
    return post('/work-order/workOrder/template/field/enableDownload', data);
};

//更新售后审核配置
export const updateConfig = (params: any) => {
    return post('/css/audit/updateConfig', params);
};

/**
 * 获取售后政策列表
 */
export const getPolicyList = (
    params: PaginationParamsPageNum<{
        product_category_code?: string;
        product_type?: string;
    }>,
) => {
    return post<
        PaginationResult<
            {
                create_time: string;
                product_category_code: number;
                product_category_name: string;
                support_repair: boolean;
                support_swap: boolean;
                exclude: {
                    product_attribute: string;
                    product_attribute_value: string;
                    support_repair: boolean;
                    support_swap: boolean;
                };
            }[]
        >
    >('/css/aftersale/policy/list', params);
};

/**
 * 获取添加售后政策时的商品属性，过滤掉已经添加过售后政策的商品属性
 */
export const getProductCategoryByCreate = () => {
    return post('/product/category/searchWithCreate');
};

// 创建三级类目 售后政策
export const createProductPolicy = (params) => {
    return post('/css/aftersale/policy/add', params);
};
// 更新三级类目 售后政策
export const updateProductPolicy = (params) => {
    return post('/css/aftersale/policy/update', params);
};

/**
 * 获取每个售后类型全量售后瑕疵原因
 */
export const getAfterSaleReasons = (params?: { small_code?: string }) => {
    return post<ApiDataType<AllTypeReason>>(
        '/aftersale/reason/config/list/sup/all',
        params,
    );
};

/**
 * 获取每个售后类型全量售后瑕疵原因
 */
export const getAllReasons = (params?: { small_code?: string }) => {
    return post<ApiDataType<AllTypeReason>>(
        '/aftersale/reason/config/list/all',
        params,
    );
};

/**
 * 获取商品属性售后瑕疵原因配置
 */
// export const getReasonBySmallCode = (params?: { small_code: string }) => {
//     return get('/aftersale/reason/config/getBySmallCode', params);
// };

/**
 * 保存瑕疵原因
 */
export const saveReasons = (params: { reason: any }) => {
    return post('/aftersale/reason/config/save', params);
};

/**
 * 保存商品属性下的瑕疵原因，废弃
 */
// export const saveReasonsBySmallCode = (params: {
//     small_code: string;
//     aftersale_reason_list: {
//         type: number;
//         reason_list: ReasonItem[];
//     }[];
// }) => {
//     return post('/aftersale/reason/config/saveBySmallCode', params);
// };
/**
 * 保存商品属性下的瑕疵原因
 */
export const saveByAftersaleType = (params: {
    aftersale_type: number;
    list: ReasonItem[];
}) => {
    return post('/aftersale/reason/config/saveByAftersaleType', params);
};

/**
 * 保存瑕疵原因排序
 */
export const saveReasonsSort = (params: {
    aftersale_type: number;
    list: ReasonItem[];
}) => {
    return post('/aftersale/reason/config/sort/save', params);
};
/**
 * 商品管理 - 新，获取商品列表
 */
export const getProductList = (params: { product_code: string }) => {
    return post('/css/product/list', params);
};
/**
 * 商品管理 - 新，获取商品售后政策详情
 */
export const getPolicyDetail = (params: { product_code: string }) => {
    return get('/css/product/aftersale/policy/detail', params);
};

/**
 * 商品管理 - 新，删除商品售后政策
 */
export const delPolicy = (params: { product_code: string }) => {
    return post('/css/product/aftersale/policy/delete', params);
};

/**
 * 商品管理 - 新，新增商品售后政策
 */
export const addPolicy = (params: { product_code: string }) => {
    return post('/css/product/aftersale/policy/add', params);
};

/**
 * 商品管理 - 新，更新商品售后政策
 */
export const updatePolicy = (params: { product_code: string }) => {
    return post('/css/product/aftersale/policy/update', params);
};

/**
 * 订单渠道配置
 */
export const getChannelList = (params: { product_code: string }) => {
    return post('/css/channel/list', params);
};

/**
 * 获取 E3 店铺列表
 */
export const getChannelKhdmList = (params: any) => {
    return get('/css/channel/khdmlist', params);
};

/**
 * 新增三方渠道
 */
export const saveChannel = (params: any) => {
    return post('/css/channel/save', params);
};
/**
 * 渠道启用/ 禁用
 */
export const channelEnableChange = (params: any) => {
    return get('/css/channel/enable', params);
};

/**
 * 获取短信发送记录列表
 */
export const getSmsRecordList = (params: any) => {
    return post('/work-order/workOrder/gsms/getSmsRecordList', params);
};

/**
 * 获取模板列表
 */
export const getSmsTemplateList = (params: any) => {
    return get('/work-order/workOrder/gsms/getSmsTemplateList', params);
};

/**
 * 添加模板列表
 */
export const addSmsTemplate = (params: any) => {
    return post('/work-order/workOrder/gsms/addSmsTemplate', params);
};

/**
 * 删除模板
 */
export const delSmsTemplate = (params: any) => {
    return get('/work-order/workOrder/gsms/delSmsTemplate', params);
};

/**
 * 更新短信模板
 */
export const updateSmsTemplate = (params: any) => {
    return get('/work-order/workOrder/gsms/updateSmsTemplate', params);
};

/**
 * 编辑短信模板
 */
export const editSmsTemplate = (params: any) => {
    return post('/work-order/workOrder/gsms/editSmsTemplate', params);
};

/**
 * 发送短信
 */
export const gsmsSendSms = (params: any) => {
    return post('/work-order/workOrder/gsms/sendSms', params);
};

/**
 * 批量发送短信
 */
export const gsmsBatchSendSms = (params: any) => {
    return post('/work-order/workOrder/gsms/batchSendSms', params);
};

/**
 * 标签列表
 */
export const labelList = (params: {
    label: string;
    page_num: number;
    page_size: number;
}) => {
    return post('/css/label/list', params);
};

/**
 * 添加或更新标签
 */
export const labelAddOrUpdate = (params: { label: string; score: number }) => {
    return post('/css/label/addOrUpdate', params);
};

/**
 * 删除标签
 */
export const labelDelete = (params: { label: string }) => {
    return post('/css/label/delete', params);
};

/**
 * 获取公告列表
 */
export const appNoticeList = (params) => {
    return post('/appNotice/list', params);
};

/**
 * 添加公告
 */
export const addNotice = (params) => {
    return post('/appNotice/add', params);
};
/**
 * 编辑公告
 */
export const editNotice = (params) => {
    return post('/appNotice/edit', params);
};
/**
 * 停用公告
 */
export const appNoticeDisable = (params: { id: number }) => {
    return get('/appNotice/disable', params);
};
/**
 * qa 获取qa 列表
 */
export const getQaList = (params) => {
    return get('/qa/list', params);
};

/**
 * qa 添加 qa
 */
export const addQa = (params) => {
    return post('/qa/add', params);
};

/**
 * 编辑 qa
 */
export const editQa = (params) => {
    return post('/qa/edit', params);
};

/**
 * 删除 qa
 */
export const delQa = (id) => {
    return get('/qa/del', { id });
};

/**
 * 公告枚举
 */
export const appNoticeEnums = () => {
    return get('/appNotice/enums', {});
};

/**
 * 订单同步
 */
export const syncOrder = (params: {
    order_channel: number;
    business_child_order_no: string;
}) => {
    return post('/css/order/compensate', params);
};
